import React, { useRef, useState } from "react";
import { useRequestProcessor } from "../../../requestProcessor";
import { useAtom } from "jotai";
import { activeChildDetail } from "../../../AtomStore/store";
import { fetchTickets } from "../../../QueryFunctions/queryfunction";
import ListEmptyComponent from "../../../Layout/LoggedInLayout/ListEmptyComponent";
import moment from "moment";
import { DEFAULT_FORMAT } from "../../../Components/utils/FootprintDatePicker";
import SpinnerLoading from "../../../Components/utils/SpinnerLoading";

const Tickets = () => {
  const { useQueryWrapper } = useRequestProcessor();
  const [activeChild] = useAtom(activeChildDetail);
  const [selectedItem, setSelectedItem] = useState(null);
  const ticketModalRef = useRef();
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const statusArr = [];

  statusArr[2] = "Open";
  statusArr[3] = "Pending";
  statusArr[4] = "Resolved";
  statusArr[5] = "Closed";
  const {
    data: tickets,

    isLoading,
  } = useQueryWrapper(["pastTickets", "ticket" + activeChild?.id], () =>
    fetchTickets(activeChild)
  );

  console.log("Tickets", tickets);
  return (
    <ul className="px-2 pb-4 pt-16 [@media(min-width:640px)and(max-width:768px)]:pt-4 md:pt-4 md:grid lg:grid-cols-2 md:gap-4 lg:gap-x-8 xl:gap-x-12">
      {isLoading ? <SpinnerLoading /> : <></>}
      {Array.isArray(tickets) && tickets.length > 0 ? (
        tickets.map((item, index) => (
          <li
            className="cursor-pointer grid grid-cols-12 gap-1 mb-2 bg-white p-2 rounded-lg"
            onClick={() => {
              setSelectedItem(item);
              setIsDetailModalOpen(true);
            }}
          >
            <div className=" flex col-span-7">
              <div className=" p-1 rounded-lg flex items-center ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="size-14 bg-[#d9d9d9] text-dark rounded-lg p-2"
                >
                  <path
                    fillRule="evenodd"
                    d="M1.5 6.375c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v3.026a.75.75 0 0 1-.375.65 2.249 2.249 0 0 0 0 3.898.75.75 0 0 1 .375.65v3.026c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 17.625v-3.026a.75.75 0 0 1 .374-.65 2.249 2.249 0 0 0 0-3.898.75.75 0 0 1-.374-.65V6.375Zm15-1.125a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Zm.75 4.5a.75.75 0 0 0-1.5 0v.75a.75.75 0 0 0 1.5 0v-.75Zm-.75 3a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-1.5 0v-.75a.75.75 0 0 1 .75-.75Zm.75 4.5a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-.75ZM6 12a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 12Zm.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="ml-1 flex justify-center flex-col">
                <h3 className="text-dark text-md font-bold">
                  {item.type ? item.type : "Ticket"}
                </h3>
                {/* <h3 className='text-xs '>Requested On July,18 2024</h3> */}
                <h3 className="text-xs text-gray line-clamp-2 ">
                  {item?.subject}
                </h3>
              </div>
            </div>
            <div className="col-span-5 flex items-end justify-center flex-col">
              <h3 className="text-sm font-medium text-center text-dark">
                {moment(item.created_at, "YYYY-MM-DD HH:mm:ss").format(
                  DEFAULT_FORMAT
                )}
              </h3>
              <h3
                className={`text-md font-bold text-center ${
                  statusArr[item.status] === "Open"
                    ? "text-green-500"
                    : "text-red-500"
                }`}
              >
                {statusArr[item.status]}
              </h3>
            </div>
          </li>
        ))
      ) : (
        <div className="text-center -mt-8 w-full col-span-2 mt-12 ">
          <ListEmptyComponent
            heading={isLoading ? "Loading..." : "No Data Found"}
          />
        </div>
      )}

      {isDetailModalOpen && selectedItem && (
        <div
          ref={ticketModalRef}
          id="hs-vertically-centered-modal"
          className="hs-overlay fixed inset-0 z-[80] flex items-center justify-center overflow-x-hidden overflow-y-auto pointer-events-auto w-full bg-black/50"
          role="dialog"
          tabIndex="-1"
          aria-labelledby="hs-vertically-centered-modal-label"
        >
          <div className="mt-7 opacity-100 duration-500 ease-out transition-all sm:max-w-lg sm:w-full m-3 sm:mx-auto min-h-[calc(100%-3.5rem)] flex items-center justify-center">
            <div className="w-full flex flex-col bg-white shadow-sm rounded-xl pointer-events-auto dark:bg-neutral-800 dark:border-neutral-700 dark:shadow-neutral-700/70">
              {/* Modal Header */}
              <div className="flex text-lg justify-between items-center py-3 px-4 bg-header rounded-t-xl">
                <h3
                  id="hs-vertically-centered-modal-label"
                  className="font-bold text-white"
                >
                  Ticket Subject
                </h3>
                <button
                  onClick={() => setIsDetailModalOpen(false)}
                  className="text-white hover:text-gray-200"
                >
                  ✕
                </button>
              </div>
              {/* Modal Body */}
              <div className="p-3">
                {/* <h2 className="text-lg text-dark font-semibold">Subject</h2> */}
                <p className="text-sm text-gray-700 dark:text-gray-300">
                  {selectedItem.subject || "No subject provided."}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </ul>
  );
};

export default Tickets;
